<div>
    <div class="text-gradient modal-icon">
      <mat-icon fontSet="material-icons-outlined">check_circle</mat-icon>
    </div>
    <h1 class="modal-title">{{ title }}</h1>
    <h2 class="modal-sub-title">{{ subTitle }}</h2>
    <div class="modal-btn-container">
      <button class="modal-btn" (click)="onButtonClick()">
        {{ titleBtn }}
      </button>
    </div>
</div>
